import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};

const lineVariant = {
  hidden: { y: "110%", opacity: 0 },
  visible: {
    y: "0%",
    opacity: 1,
    transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] },
  },
};

export function KineticText({ lines, className = "", tag = "h1", testId }) {
  const Tag = tag;
  return (
    <Tag className={className} data-testid={testId}>
      <motion.span className="block" initial="hidden" animate="visible" variants={container}>
        {lines.map((text, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span className="block" variants={lineVariant}>
              {text}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}
